<div>
  <h1>{{ 'Intellitrailer.NfcRequired.Title' | translate : 'Enable Nfc to continue'}}</h1>

  <app-card>
    <img src="/Images/EnableNfc.png" />

    <h2>{{'Intellitrailer.NfcRequired.SubTitle' | translate : 'Nfc is required to scan the trailer' }}</h2>
    <p>{{ 'Intellitrailer.NfcRequired.Text' | translate : 'You need to enable the NFC service on your device to continue'}}</p>
  </app-card>
</div>
